<template>
    <div class="pm ">
        <el-row class="video-tree flex" >
            <el-col :span="treespan" v-show="isright" :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <left-tree @showData="showData" @getid="getid"></left-tree>
            </el-col>
            <el-col :span="rightspan"  style="height: 100%;min-width: 320px;width: 100%">
                <div style="display:flex;justify-content: space-between">
                    <div class="p5" style="margin-right: 20px;display: flex;align-items: center">
                        <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>

                        <el-button class="marB10" @click="addinside" :class="baseerp+'btn'" size="mini">
                            新增内部用户
                        </el-button>
                        <el-button class="marB10" @click="addoutside " :class="baseerp+'btn'" size="mini" >
                            新增外部用户
                        </el-button>
                        <el-button class="marB10" @click="shouquan" :class="baseerp+'btn'" size="mini">
                            批量授权
                        </el-button>

                    </div>
                    <div style="margin-right: 20px;display: flex;align-items: center">

                        <span class="titlew" style="font-size: 14px">启用状态</span>
                        <el-select
                                size="mini"
                                style="width: 200px ; margin-right:10px;margin-left: 5px"
                                placeholder="请选择启用状态"
                                clearable class="input-width"
                                v-model="isqiyong"
                                filterable>
                            <el-option
                                    v-for="item in qiyongdata"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <span class="titlew" style="font-size: 14px">同步状态</span>
                        <el-select
                                size="mini"
                                style="width: 200px ; margin-right:10px;margin-left: 5px"
                                placeholder="请选择同步状态"
                                clearable class="input-width"
                                v-model="istongbu"
                                filterable>
                            <el-option
                                    v-for="item in tongbudata"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <!-- 搜索框 -->
                        <el-input
                                size="mini"
                                style="width: 200px  "
                                placeholder="请输入搜索内容"
                                v-model="search"
                                clearable>
                        </el-input>
                        <!-- 搜索按钮 -->
                        <el-button  class="mrl15 " icon="el-icon-search" circle  @click="searchall" size="mini"></el-button>
                    </div>
                </div>

                <el-table
                        class="mrt10"
                        ref="table"
                        size="mini"
                        :height="tableHeight"
                        border
                        v-loading="sloading"
                        :data="tableData"
                        row-key="id"
                        @selection-change="selectchange"
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        :highlight-current-row="true"
                        style="width: 100%">
                    <el-table-column
                            :reserve-selection="true"
                            :selectable="selectjudge"
                            align="center"
                            width="55"
                            type="selection">
                    </el-table-column>
                    <!--<el-table-column
                            align="center"
                            label="规则ID"
                            prop="stateTxt" show-overflow-tooltip>
                    </el-table-column>-->
                    <el-table-column
                            align="center"
                            width="80"
                            label="用户名"
                            prop="name" show-overflow-tooltip>
<!--                        <template slot-scope="scope" >-->
<!--                          -->
<!--                        </template>-->
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="部门"
                            prop="dept" show-overflow-tooltip>

                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="手机号"
                             show-overflow-tooltip>
                        <template slot-scope="scope" >
                            <span>{{scope.row.phone==''?'无':scope.row.phone}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="微信号"
                            show-overflow-tooltip
                           >
                        <template slot-scope="scope" >
                            <span>{{scope.row.wxContact==''?'无':scope.row.wxContact}}</span>
                        </template>
                    </el-table-column><el-table-column
                        align="center"
                        label="NFC卡号"
                        >
                    <template slot-scope="scope" >
                        <span>{{scope.row.nfc==''?'无':scope.row.nfc}}</span>
                    </template>

                </el-table-column><el-table-column
                        align="center"
                        label="授权应用"
                        show-overflow-tooltip
                        >
                    <template slot-scope="scope" >
                        <span>{{scope.row.app==''?'无':scope.row.app.substring(0,scope.row.app.length-1)}}</span>
                    </template>
                </el-table-column><el-table-column
                        align="center"
                        label="类型"
                        width="60"
                        prop="type">

                </el-table-column><el-table-column
                        align="center"
                        width="70"

                        label="是否管理"
                        prop="isAdmin">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.isAdmin==1" style="color: #03cb45">✔</span>
                        <span v-else style="color: red">✖</span>
                    </template>
                </el-table-column><el-table-column
                        align="center"
                        width="70"
                        label="是否同步"
                        prop="isSync">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.isSync==0" style="font-weight: 700">未同步</span>
                        <span v-if="scope.row.isSync==-1" style="font-weight: 700;color: red">同步失败</span>
                        <span v-if="scope.row.isSync==1" style="color: #2b89fd;font-weight: 700">已同步</span>
                        <span v-if="scope.row.isSync==2" style="color: #E89112;font-weight: 700">同步中</span>
                    </template>
                </el-table-column><el-table-column
                        align="center"
                        width="60"
                        label="是否启用"
                        prop="state">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.state==1" style="color: #03cb45">✔</span>
                        <span v-else style="color: red">✖</span>

                    </template>
                </el-table-column>
                    <el-table-column
                            align="center"
                            label="录入人"
                            width="70"
                            prop="lruName">

                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="注册时间"
                            prop="registerTime"
                    show-overflow-tooltip>

                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="操作"
                            >
                        <template slot-scope="scope" >
                            <el-button size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
                            <el-button size="mini" type="text" style="color: red" @click="deleteuser(scope.row)">{{$t('button_nullify')}}</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <!--        分页器-->
                <div class="block">
                    <div class="pages">
                        <div class="choosepage flexother mrt20 fl">
                            <el-pagination
                                    small

                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="this.currentPage"
                                    :page-sizes="[10, 50, 100, 400]"
                                    :page-size="this.pageSize"
                                    layout="total,sizes"
                                    :total="this.total"
                            >
                            </el-pagination>
                            <el-pagination
                                    small
                                    :pager-count="5"
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="this.currentPage"
                                    :page-size="this.pageSize"
                                    layout="prev, pager, next, jumper"
                                    :total="this.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
<!--        <el-dialog   title="新增外部用户"  :destroy-on-close="true" :close-on-click-modal="false" :show-close="false" v-if="outdialog" :visible.sync="outdialog">-->
            <el-dialog
                    :close-on-click-modal="false"
                    style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                    width="520px"

                    :title="outtitle"
                    :visible.sync="outdialog"
                    v-if="outdialog"
            >
            <add-out-side-user :sqtypedata="sqtypedata" @savesuccess="savesuccess" :editData="editData" @closedialog="closedialog" :deptid="deptid"></add-out-side-user>
        </el-dialog>
<!--        <el-dialog   title="新增内部用户"  :destroy-on-close="true" :close-on-click-modal="false" :show-close="false" v-if="innerdialog" :visible.sync="innerdialog">-->
        <el-dialog
                :close-on-click-modal="false"

                title="新增内部用户"
                :visible.sync="innerdialog"
                width="60%"
                v-if="innerdialog"
        >
        <add-inner-user @savesuccess="savesuccess" @closedialog="closedialog" :deptid="deptid"></add-inner-user>
        </el-dialog>

        <el-dialog
                :close-on-click-modal="false"
                class="biaoge"
                title="用户授权"
                :visible.sync="shouquandialog"
                width="60%"
                v-if="shouquandialog"
        >
            <shouquan :selectalldata="selectalldata" @savesuccess="savesuccess" @closedialog="closedialog" :deptid="deptid"></shouquan>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialogVisible"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialogVisible"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">是否确认作废</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delDialogVisible = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>
    </div>

</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import LeftTree from "./component/leftTree";
    import addInnerUser from "./component/addInnerUser";
    import addOutSideUser from "./component/addOutSideUser";
    import shouquan from "./component/shouquan";
    export default {
        name: "index",
        components: {LeftTree,addInnerUser,addOutSideUser,shouquan},
        data() {
            return {
                typesearch:'',
                ceshi:0,
                qiehuanbtn:false,
                delbtn:false,
                editbtn:false,
                sloading:false,
                qiyongdata:[
                    {
                        id:0,
                        value:'禁用'
                    },
                    {
                        id:1,
                        value:'启用'
                    }
                ],
                typedata:[
                    {
                        id:1,
                        value:'内部'
                    },
                    {
                        id:2,
                        value:'外部'
                    }
                ],
                tongbudata:[
                    {
                        id:0,
                        value:'未同步'
                    },
                    {
                        id:1,
                        value:'已同步'
                    },{
                        id:2,
                        value:'同步中'
                    },{
                        id:-1,
                        value:'同步失败'
                    }
                ],
                isqiyong:'',
                istongbu:'',
                search:'',
                outtitle:'',
                sqtypedata:[],
                outdialog:false,
                shouquandialog:false,
                innerdialog:false,
                pageSize:10,
                currentPage:1,
                isright:true,
                total:0,
                tableData:[],
                delDialogVisible:false,
                tableHeight:0,//列表高度
                baseerp:'',
                deldata:{},
                treespan:4,
                rightspan:20,
                deptid:'',
                deptstate:'',
                editData:{},
                selectdata:[],
                type:0,
                selectalldata:[],
                searchbtn:false
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            selectjudge(row,index){
                if(row.isSync==2||row.wxContact==''){
                    return false
                }else{
                    return true
                }

            },
            selectchange(e){
                // console.log(1)
                this.selectdata=e
                // this.selectdata=e
                // if(this.selectdata.length==0){
                //     this.selectdata.push({
                //         page:this.currentPage,
                //         list:e
                //     })
                // }else{
                //     if(this.selectdata.findIndex(sitem=>{
                //         return sitem.page==this.currentPage
                //     })==-1){
                //         this.selectdata.push({
                //             page:this.currentPage,
                //             list:e
                //         })
                //     }else{
                //         this.selectdata.forEach(item=>{
                //             if(item.page==this.currentPage){
                //                 item.list=e
                //             }
                //         })
                //     }
                // }
                // console.log(this.selectdata)
            },
            searchall(){
                if(this.deptid!==''){

                        this.searchbtn=true

                    this.currentPage=1
                    this.getWxUserList()
                }

            },
            savesuccess(){
                this.searchbtn=false
                this.selectdata=[]
                this.$refs.table.clearSelection()
                this.tableData=[]
                this.currentPage=1
                if(this.editData.add!==1){
                    this.search=''
                    this.istongbu=''
                    this.isqiyong=''
                }else{
                    this.searchbtn=true
                }

                if(this.innerdialog){
                    this.getWxUserList()
                    this.innerdialog=false
                }else{
                    this.outdialog=false
                    this.shouquandialog=false
                    this.sloading=true
                    setTimeout(()=>{

                        this.getWxUserList()
                    },1000)
                }

            },
            closedialog(){
              this.innerdialog=false
                this.shouquandialog=false

                this.outdialog=false
            },
            addinside(){
                if(this.deptstate==''&&this.deptid!==0){
                    this.$message.error('请选择部门后新增');
                }else{
                    this.innerdialog=true
                    this.outdialog=false
                }
            },
            getid(val){
                this.deptid=val.i_id
                this.deptstate=val.i_state
            },
            addoutside(){
                if(this.deptid!==-1){
                    this.$message.error('请选择外部人员列表后新增');
                }else{
                    this.outtitle='新增外部用户'
                    this.editData={
                        name:'',
                        isAdmin:0,
                        isSync:0,
                        state:1,
                        type:'2',
                        appList:[],
                        nfc:'',
                        wxContact:'',
                        phone:'',
                        add:0
                    }
                    this.innerdialog=false
                    this.outdialog=true
                }

            },
            edit(val){
                this.outtitle='编辑用户'
                if(!this.editbtn){
                    this.getAppList(val)
                }
            },
            shouquan(){
                if(this.selectdata.length!=0){
                    let a=[]
                    // this.selectdata.forEach(item=>{
                        a=[...a,...this.selectdata]
                    // })
                    this.selectalldata=a
                    this.shouquandialog=true

                }else{
                    this.$message.error('请选择人员后授权')
                }
            },
            submitdel(){
                if(!this.delbtn){
                    this.voidWxUser()
                }
            },
            deleteuser(val){
                this.deldata=val
            this.delDialogVisible=true
            },
            //分页
            handleSizeChange(val) {
                this.pageSize = val;    //动态改变
                this.getWxUserList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getWxUserList()
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },
            showData(val){
                this.searchbtn=false
                this.ceshi++
                this.$refs.table.clearSelection()
                this.selectdata=[]
                if(val.i_id==0){
                    this.type=1
                }else if(val.i_id==-1){
                    this.type=2
                }else{
                    this.type=1
                }
                    this.currentPage = 1
                    this.deptid=val.i_id
                    this.deptstate=val.i_state
                    this.search=''
                    this.istongbu=''
                    this.isqiyong=''
                    this.getWxUserList()
            },
            async getWxUserList(){

                // this.total=0
                const ceshishuju=this.ceshi
                this.qiehuanbtn=true
                this.tableData=[]
                    let param = {
                        deptId:this.deptid,
                        pageNum:this.currentPage,
                        pageSize:this.pageSize,
                        type:this.type,
                        state:!this.searchbtn?-1:(this.isqiyong!==''?this.isqiyong:-1),
                        isSync:!this.searchbtn?-11:(this.istongbu!==''?this.istongbu:-11),
                        search:!this.searchbtn?'':this.search
                    };
                    let res = await API.getWxUserList(param);
                    if (res.code == 1) {
                        this.qiehuanbtn=false

                        this.sloading=false
                        if(this.ceshi==ceshishuju){
                            this.tableData=res.data
                            this.total=res.total

                        }
                        // console.log(this.selectdata)
                        // if(this.selectdata.length!==0){
                        //     let a=[]
                        //     this.selectdata.forEach(item=>{
                        //             a.push(item.id)
                        //     })
                        //     this.$nextTick(()=>{
                        //         this.tableData.forEach(item=>{
                        //             if(a.indexOf(item.id) > -1){
                        //                 this.$refs.table.toggleRowSelection(item,true)
                        //             }else{
                        //                 this.$refs.table.toggleRowSelection(item,false)
                        //             }
                        //         })
                        //     })
                        //
                        // }
                    } else if (res.code == -2) {
                        this.sloading=false
                        this.qiehuanbtn=false

                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.sloading=false
                        this.qiehuanbtn=false

                        this.$message.error(res.message);
                    }
            },
            async getUserInfo(val){
                let param = {
                    id:val.id
                };
                let res = await API.getUserInfo(param);
                if (res.code == 1) {
                    this.editbtn=false

                    this.editData=res.data
                    this.$set(this.editData,'add',1)
                    this.outdialog=true
                } else if (res.code == -2) {
                    this.editbtn=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.editbtn=false

                    this.$message.error(res.message);
                }
            },
            async voidWxUser(){
                this.delbtn=true
                let param = {
                    id:this.deldata.id,
                    registerTime:this.deldata.registerTime,
                    validateCode:this.deldata.validateCode,
                    validateKeynames:this.deldata.validateKeynames,
                    type:this.deldata.type=='外部'?2:1,
                    mainTable:this.deldata.mainTable,
                    lruid:sessionStorage.getItem("userid"),
                };
                let res = await API.voidWxUser(param);
                if (res.code == 1) {
                    this.delbtn=false

                    this.delDialogVisible=false
                    this.currentPage=1
                    // this.currentPage=1
                    this.search=''
                    this.istongbu=''
                    this.isqiyong=''
                    this.getWxUserList()
                    this.$message.success(res.message);

                } else if (res.code == -2) {
                    this.delbtn=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.delbtn=false

                    this.$message.error(res.message);
                }
            },
            async getAppList(val) {
                this.editbtn=true
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    type:this.deptid==0?1:(this.deptid==-1?2:1)
                }
                let res = await API.getAppList(params);
                if (res.code == 1) {
                    this.sqtypedata=res.data
                    this.getUserInfo(val)
                } else if (res.code == -2) {
                    this.editbtn=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.editbtn=false

                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>

    .flex{
        display: flex;
    }
    .p5{
        padding: 5px 0;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    /deep/.biaoge .el-dialog__body{
        padding:20px 40px 40px 40px !important;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .color409eff{
        color: var(--light) !important;
        display: inline-block;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 840px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        /*.el-dialog__title,.el-dialog__headerbtn .el-dialog__close {*/
        /*    color: white;*/
        /*}*/

    }

    /*.el-dialog__title,.el-dialog__headerbtn .el-dialog__close {*/
    /*    color: white;*/
    /*}*/
</style>